<i18n>
{
	"en": {
		"PleaseInputToSearch": "Please input to search"
	},
	"vi": {
		"PleaseInputToSearch": "Gõ tên tag để tìm kiếm."
	}
}
</i18n>

<template>
	<div>
		<!-- Block tag employee, departement, title -->
		<div class="container-watcher--block-item">
			<h6 class="mt-5 custom-component--title">{{ title ? title : $t("ApplyTag") }}:</h6>
			<v-select
				:ref="ref"
				label="name"
				v-bind="$attrs"
				v-on="$listeners"
				:filterable="false"
				:multiple="multiple"
				:options="tags"
				:placeholder="`${$t('Actions.Choose')} ${placeholder ? placeholder : $t('Tag').toLowerCase()}`"
				@search="fetchOptions"
				:class="['bg-white', { 'select-multiple': multiple }]"
				:closeOnSelect="true"
				:getOptionKey="option => ref + option.id"
				:reduce="tag => tag.id"
			>
				<template #no-options>
					{{ $t("PleaseInputToSearch") }}
				</template>
			</v-select>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";

import * as _ from "lodash";

export default {
	inheritAttrs: false,
	name: "CbsTags",
	props: {
		title: {
			type: String
		},
		placeholder: {
			type: String
		},
		multiple: {
			type: Boolean,
			default: true
		}
	},
	components: {
		"v-select": vSelect
	},
	data() {
		return {
			tags: [],
			ref: _.uniqueId("tags_")
		};
	},
	methods: {
		fetchOptions(search, loading) {
			clearTimeout(this.timer);
			this.timer = setTimeout(async () => {
				if (!loading) {
					loading = this.$refs[this.ref] && this.$refs[this.ref].toggleLoading;
				}

				loading(true);
				try {
					await this.fetchTags(search);
					loading(false);
				} catch (error) {
					loading(false);
				}
			}, 400);
		},
		async fetchTags(search = "") {
			try {
				const response = await this.$store.dispatch("fetchSetSystemTags", { search });
				if (response) {
					this.tags = response || [];
				}
			} catch (error) {
				console.error("fetchTags", error);
			}
		}
	},
	created() {
		this.fetchTags();
	}
};
</script>
<style lang="scss">
.container-watcher--block-item {
	.vs__selected {
		.inline-block {
			line-height: 100%;
		}
		.nucleo {
			color: var(--color-white);
		}
	}
}
</style>
